import React from 'react';

const BlankLinkTo = props => {
  return <a target='_blank' rel='noopener noreferrer' {...props} />;
};

export default BlankLinkTo;
